import { useQuery } from '@apollo/client';
import { GRAPHQL_MINHAS_ACOES } from 'gql/perfil';
import { useCallback, useMemo } from 'react';

interface IQuery {
    minhasAcoes?: {
        administrador?: boolean;
        acoes?: string[];
    };
}

export const usePermissao = () => {
    const { data, loading } = useQuery<IQuery>(GRAPHQL_MINHAS_ACOES, {
        fetchPolicy: 'cache-first',
    });
    const administrador = !!data?.minhasAcoes?.administrador;
    const acoes = useMemo(
        () => new Set<string>(data?.minhasAcoes?.acoes || []),
        [data],
    );
    const can = useCallback(
        (chave: string) => administrador || acoes.has(chave),
        [administrador, acoes],
    );

    return { can, administrador, loading };
};
